// Self-contained haversine so this helper has no Google Maps / driverUtils dependency.
function getDistanceInKm(lat1, lon1, lat2, lon2) {
    const toRad = deg => deg * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// Fallback seats per vehicle type when the backend omits maxSeat.
const DEFAULT_SEATS = { 2: 1, 4: 4, 6: 6, 7: 7 };

export function getSeatCapacity(vehicle, vehicleType) {
    const seats = Number(vehicle?.maxSeat);
    if (Number.isFinite(seats) && seats > 0) return seats;
    return DEFAULT_SEATS[Number(vehicle?.VTyp ?? vehicleType)] || 4;
}

// Pixel offset for the n-th marker in a group: right, left, further right, ...
export const slotOffset = (index, start = 28, gap = 48) =>
    (start + Math.floor(index / 2) * gap) * (index % 2 === 0 ? 1 : -1);

// Groups markers whose positions lie within radiusMeters of each other and
// returns Map<key, pixelOffset> so they render side by side instead of stacking.
export function getSideBySideOffsets(items, getPosition, getKey, radiusMeters = 25) {
    const groups = [];
    const offsets = new Map();
    items.forEach(item => {
        const pos = getPosition(item);
        const lat = Number(pos?.lat);
        const lng = Number(pos?.lng);
        let group = groups.find(g =>
            getDistanceInKm(g.lat, g.lng, lat, lng) * 1000 <= radiusMeters);
        if (!group) {
            group = { lat, lng, count: 0 };
            groups.push(group);
        }
        offsets.set(String(getKey(item)), slotOffset(group.count++));
    });
    return offsets;
}

// Onboard passengers always show; waiting passengers fill only the free
// seats, nearest to the driver first.
export function limitPassengersToSeats(passengers, onboardIds, seatCapacity, driverPos) {
    const onboard = passengers.filter(p => onboardIds.includes(String(p.ReqNo)));
    const seatsLeft = Math.max(0, seatCapacity - onboard.length);
    const dist = p => driverPos
        ? getDistanceInKm(Number(driverPos.lat), Number(driverPos.lng), Number(p.lat), Number(p.lng))
        : 0;
    const waiting = passengers
        .filter(p => !onboardIds.includes(String(p.ReqNo)))
        .sort((a, b) => dist(a) - dist(b))
        .slice(0, seatsLeft);
    return [...onboard, ...waiting];
}
